import React, { useState, useEffect } from 'react';
import { useQuery } from 'convex/react';
import { api } from '../convex/_generated/api';

// Helper component to handle claim status queries
const PassClaimStatusWrapper = ({ pass, userDoc, children }) => {
  const [isClaimedThisWeek, setIsClaimedThisWeek] = useState(false);
  const [actionType, setActionType] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const currentWeekClaims = useQuery(
    api.getAvailablePasses.getUserPassClaimsForCurrentWeek,
    userDoc?._id && pass._id ? { userId: userDoc._id, passId: pass._id } : "skip"
  );

  useEffect(() => {
    if (currentWeekClaims !== undefined) {
      setIsClaimedThisWeek(currentWeekClaims.length > 0);
      // Get the action type from the most recent claim
      if (currentWeekClaims.length > 0) {
        // Sort by claimedAt date (newest first) and take the most recent
        const sortedClaims = [...currentWeekClaims].sort((a, b) => 
          new Date(b.claimedAt).getTime() - new Date(a.claimedAt).getTime()
        );
        setActionType(sortedClaims[0].actionType);
      } else {
        setActionType(null);
      }
      setIsLoading(false);
    }
  }, [currentWeekClaims]);

  return children(isClaimedThisWeek, actionType, isLoading);
};

export default PassClaimStatusWrapper; 